import { getPayServiceClient } from './payServiceClient';
import { PaymentServicesObj } from '../general/orderbox/order_box';
import { getUserSuid } from '../general/modules/getUserSuid';
import { PaymentObject } from '../types/payments';
import { PaymentServices } from './paymentServices';
import { ClientEventEmitter } from '../marketing/ClientEventEmitter';
import { ClientEvents } from '../constants/clientEvents';
import { CurrentUser } from '../general/modules/user/currentUser';

type InitiateTransactionResponse = number

export class PayService {
    public static async getMethods(): Promise<PaymentServicesObj> {
        const data: GetAllPaymentMethods = {
            amount: window.app.last_payment_object.price,
            country: window.app.config.country,
            currency: window.app.last_payment_object.currency,
            locale: window.app.config.locale,
            suid: CurrentUser.getInstance().getSuid()
        };

        return getPayServiceClient().getPaymentMethodsV2(data);
    }

    public static async initiateTransaction(
        pmObject: PaymentObject,
        payService: PaymentServices
    ): Promise<InitiateTransactionResponse> {
        const transactionId = await this.createTransaction(pmObject, payService);

        this.setLastPaymentMethod(payService);
        ClientEventEmitter.fireEvent(ClientEvents.PAYMENT_PROCEED, {
            paymentId: pmObject.id,
            paymentMethod: payService,
            transactionId
        });

        return transactionId;
    }

    private static createTransaction(
        pmObject: PaymentObject,
        payService: PaymentServices
    ): Promise<InitiateTransactionResponse> {
        const client = getPayServiceClient();
        const params = {
            payService,
            suid: getUserSuid(),
            suid_simulate: getUserSuid(true)
        };

        // Koopetz takes the price and the entry point from the game server and the token, so neither is sent.
        return client.initiateV2({
            ...params,
            pmObject: {
                currency: pmObject.currency,
                description: pmObject.description,
                guid_receiver: pmObject.guid_receiver,
                id: pmObject.id,
                name: pmObject.name
            }
        });
    }

    private static setLastPaymentMethod(payService: PaymentServices): void {
        if (payService) {
            window.app.lastPaymentMethod = payService;
            return;
        }

        window.Sentry.captureException(payService);
    }
}

type GetAllPaymentMethods = {
    country: string,
    currency: string
    amount: number
    locale: string
    suid: string
}

export type PaymentMethod = {
    isInFrame?: boolean,
    weight: number
    isCard?: boolean
    isBaseCardMethod?: boolean,
    universalCheckout?: boolean
};

export type PaymentMethodsObj = {
    [key: string]: PaymentMethod
};
